<script lang="ts">
    import UnstyledButton from "@components_v2/Button/UnstyledButton.svelte";
    import Icon from "@components_v2/Icon.svelte";
    import ChevronLeftIcon from "@components_v2/Icons/ChevronLeftIcon.svelte";
    import ChevronRightIcon from "@components_v2/Icons/ChevronRightIcon.svelte";
    import { createEventDispatcher } from "svelte";

    export let hasNext = true;
    export let hasPrev = true;
    const dispatch = createEventDispatcher();
    const handleNextSlide = (): void => {
        dispatch("nextSlide");
    };
    const handlePrevSlide = (): void => {
        dispatch("prevSlide");
    };
</script>

<div class="gw-rv-product-mini-slider-arrows">
    {#if hasPrev}
        <UnstyledButton
            ariaLabel="Previous review slide"
            class="gw-rv-product-mini-slider-arrows__arrow gw-rv-product-mini-slider-arrows__arrow--prev"
            on:click={handlePrevSlide}
        >
            <Icon width={16} height={16}>
                <ChevronLeftIcon />
            </Icon>
        </UnstyledButton>
    {/if}

    {#if hasNext}
        <UnstyledButton
            ariaLabel="Next review slide"
            class="gw-rv-product-mini-slider-arrows__arrow gw-rv-product-mini-slider-arrows__arrow--next"
            on:click={handleNextSlide}
        >
            <Icon width={16} height={16}>
                <ChevronRightIcon />
            </Icon>
        </UnstyledButton>
    {/if}
</div>

<style lang="postcss" global>
    .gw-rv-product-mini-slider-arrows {
        & .gw-unstyled-btn.gw-rv-product-mini-slider-arrows__arrow {
            position: absolute;
            top: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            transform: translateY(-50%);

            &--prev {
                left: 0.5em;
            }

            &--next {
                right: 0.5em;
            }
        }
    }
</style>
